import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cadae42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "tabs__tab" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "tabs__tab"
}
const _hoisted_8 = { class: "tabs__tab" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "tabs__tab" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "tabs__tab" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "tabs__tab active" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Endringslogg")
], -1))
const _hoisted_15 = { class: "changelogs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Changelogs = _resolveComponent("Changelogs")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, "Endre produkt - " + _toDisplayString(_ctx.product.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        color: "primary",
        type: "a",
        class: "actions__button",
        href: "/products/view-product/list-product/"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Tilbake til produktliste")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printPriceTag()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut prislapp")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printPriceTag(true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut liten prislapp")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printPriceTag(false, true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut kampanjeprislapp")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        color: "info",
        class: "actions__button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printPriceTag(true, true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Skriv ut liten kampanjeprislapp")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        color: "yellow",
        type: "a",
        class: "actions__button",
        href: `/products/?duplicate-product=${_ctx.product.id}`
      }, {
        default: _withCtx(() => [
          _createTextVNode("Dupliser produkt")
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", { href: _ctx.legacyBaseUrl }, "Detaljer", 8, _hoisted_6)
      ]),
      (_ctx.product.type !== 'variation')
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createVNode(_component_Link, {
              href: _ctx.route('products.variations', {product:_ctx.product.id})
            }, {
              default: _withCtx(() => [
                _createTextVNode("Varianter")
              ]),
              _: 1
            }, 8, ["href"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("a", {
          href: `${_ctx.legacyBaseUrl}#sale`
        }, "Salg", 8, _hoisted_9)
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("a", {
          href: `${_ctx.legacyBaseUrl}#gallery`
        }, "Produkt galleri", 8, _hoisted_11)
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createElementVNode("a", {
          href: `${_ctx.legacyBaseUrl}#statistics`
        }, "Statistikk", 8, _hoisted_13)
      ]),
      _hoisted_14
    ]),
    _createVNode(_component_Card, { class: "tab-content" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Changelogs, {
              field: _ctx.field,
              changelogs: _ctx.changelogs
            }, null, 8, ["field", "changelogs"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}